import { Link } from "react-router-dom";
import { ArrowUpRight, Download } from "lucide-react";
import { site } from "@/content/site";

const Block = ({ title, children, testid }) => (
  <section className="py-8 border-t border-[var(--line)]" data-testid={testid}>
    <h2 className="font-mono-x text-xs tracking-[0.2em] uppercase text-[var(--ink-muted)] mb-5">{title}</h2>
    {children}
  </section>
);

const ImgLink = ({ item }) => (
  <a href={item.href} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center h-16 bg-white border border-[var(--line)] px-4 hover:border-[var(--emerald)] transition-colors" data-testid={`sidebar-${item.name.toLowerCase()}`}>
    <img src={item.image} alt={item.name} loading="lazy" className="max-h-7 w-auto object-contain" />
  </a>
);

export const JournalSidebar = ({ journal }) => (
  <aside aria-label="Journal sidebar" className="lg:sticky lg:top-28" data-testid="journal-sidebar">
    <div className="bg-[var(--emerald)] text-[var(--paper)] p-8 mb-2">
      <p className="font-display text-3xl leading-tight mb-6">Ready to share your research with {journal.abbr}?</p>
      <Link to={`/index.php/${journal.slug}/about/submissions`} className="group inline-flex items-center gap-2 h-12 px-6 rounded-full bg-[var(--paper)] text-[var(--emerald)] hover:bg-[var(--gold)] transition-colors" data-testid="sidebar-make-submission">
        Make a Submission <ArrowUpRight className="w-4 h-4 transition-transform group-hover:rotate-45" />
      </Link>
    </div>
    <Block title={site.template.label} testid="sidebar-template">
      <a href={site.template.href} className="flex items-center gap-4 group" data-testid="sidebar-template-download">
        <img src={site.template.image} alt="Word template" className="h-12 w-auto border border-[var(--line)] bg-white p-1" />
        <span className="flex items-center gap-2 text-[var(--emerald)] font-medium link-u"><Download className="w-4 h-4" /> Download .docx</span>
      </a>
    </Block>
    <Block title="Indexing sites" testid="sidebar-indexing">
      <div className="grid grid-cols-2 gap-3">{site.indexing.map((i) => <ImgLink key={i.name} item={i} />)}</div>
    </Block>
    <Block title="Recommended tools" testid="sidebar-tools">
      <div className="grid grid-cols-2 gap-3">{site.tools.map((i) => <ImgLink key={i.name} item={i} />)}</div>
    </Block>
    <Block title="Information" testid="sidebar-information">
      <ul className="space-y-2">
        {["readers", "authors", "librarians"].map((t) => (
          <li key={t}><Link to={`/index.php/${journal.slug}/information/${t}`} className="link-u capitalize" data-testid={`sidebar-info-${t}`}>For {t}</Link></li>
        ))}
      </ul>
    </Block>
  </aside>
);
